export const TextAlign = {
	left: "Left",
	center: "Center",
	right: "Right"
}
